import { StyleSheet } from "@react-pdf/renderer"
import { colors } from "../styles"

export const styles = StyleSheet.create({
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 10,
    display: "flex",
    flexDirection: "row",
    alignContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: "10px 0",
    fontFamily: "Poppins",
  },
  footerInfo: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    gap: 4,
  },
  footerText: {
    fontSize: 7,
    lineHeight: 1,
    color: `${colors.gray["30"]}`,
    fontWeight: 500,
  },
  footerTextBold: {
    fontSize: 7,
    lineHeight: 1,
    fontWeight: 600,
    color: `${colors.gray[8]}`,
  },
  footerPagination: {
    fontSize: 7,
    lineHeight: 1,
    color: `${colors.gray["30"]}`,
    fontWeight: 500,
  },
})
